/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { decode } from '@msgpack/msgpack';

export async function getGeodata() {
  const response = await fetch('/geodata.msgpack');
  const data = await response.arrayBuffer();
  return decode(data);
}
